// Module
var code = "<react-component name=\"LookupTab\" props=\"{\nhandleRemoveData: handleRemoveData\n}\"></react-component>\n";
// Exports
module.exports = code;